import style from './Header.module.css';
import icons from '../../../../img/icons/icons';
import { SocialNetworks } from '../socialNetworks/SocialNetworks';
import { ButtonActionMini } from '../../buttons/actionMini/ButtonActionMini';
import { Menu } from '../menu/Menu';
import React, { useEffect } from 'react';

export const Header: React.FC = () => {
    const clickAreaAluno = () => {
        window.location.href = 'https://ead.ouromoderno.com.br';
    }

    useEffect(() => {
        if ((window as any).particlesJS) {
            (window as any).particlesJS('particles-js', {
                particles: {
                    number: { value: 60, density: { enable: true, value_area: 800 } },
                    color: { value: "#ffffff" },
                    shape: { type: "circle" },
                    opacity: { value: 0.5, anim: { enable: false } },
                    size: { value: 3, random: true },
                    line_linked: { enable: true, distance: 150, color: "#ffffff", opacity: 0.4, width: 1 },
                    move: { enable: true, speed: 2, direction: "none", random: false, straight: false, out_mode: "out" }
                },
                interactivity: {
                    events: { onhover: { enable: true, mode: "repulse" }, onclick: { enable: true, mode: "push" } },
                    modes: { repulse: { distance: 100, duration: 0.4 }, push: { particles_nb: 4 } }
                },
                retina_detect: true
            });
        }
    }, []);

    return (
        <div className={style.Content}>
            <div id="particles-js" style={{ position: 'absolute', width: '100%', height: '100%', zIndex: 0 }}></div>
            <div className={style.BussinessArea} style={{ position: 'relative', zIndex: 1 }}>
                <div className={style.SocialMediasArea}>
                    <div className={style.AreaAluno}>
                        {/* Botão de menu agora primeiro */}
                        <div className={style.MobileMenuTrigger}>
                            <Menu />
                        </div>
                        <ButtonActionMini icon={icons.AreaAluno} click={clickAreaAluno} />
                        <button type="button" onClick={clickAreaAluno}> Área do Aluno </button>
                    </div>
                    
                    <SocialNetworks />
                </div>
                <div className={style.BussinessLogoArea}>
                    <img src={icons.BussinesLogo} alt="" />
                </div>
            </div>
            {/* O menu desktop continua aqui */}
            <div className={style.MenuArea} style={{ position: 'relative', zIndex: 1 }}>
                <Menu />
            </div>
        </div>
    );
};


